import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    // Lĩnh vực thiết kế quy hoạch xây dựng
    {
      id: 1,
      title: "Dự án ĐTXD mở rộng trường THPT Mạc Đĩnh Chi, quận Dương Kinh",
      category: "quy-hoach",
      client: "Trung tâm phát triển quỹ đất và quản lý dự án quận Dương Kinh",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập đồ án quy hoạch chi tiết rút gọn tỷ lệ 1/500",
      services: ["Lập đồ án quy hoạch chi tiết rút gọn tỷ lệ 1/500"]
    },
    {
      id: 2,
      title: "Dự án xây dựng công viên cây xanh, quảng trường tại khu trung tâm hành chính quận Dương Kinh",
      category: "quy-hoach",
      client: "Ban QLDA đầu tư xây dựng quận Dương Kinh",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập quy hoạch chi tiết rút gọn tỷ lệ 1/500",
      services: ["Lập quy hoạch chi tiết rút gọn tỷ lệ 1/500"]
    },
    {
      id: 3,
      title: "Công trình nhà máy đóng mới và sửa chữa tàu biển tại xã Hoàng Động, huyện Thủy Nguyên",
      category: "tu-van",
      client: "Công ty TNHH đóng tàu Damen – Sông Cấm",
      location: "Hải Phòng",
      year: "2025",
      description: "Tư vấn lập nhiệm vụ quy hoạch, lập đồ án quy hoạch chi tiết tỷ lệ 1/500",
      services: ["Tư vấn lập nhiệm vụ quy hoạch", "Lập đồ án quy hoạch chi tiết tỷ lệ 1/500"]
    },
    {
      id: 4,
      title: "Dự án điều chỉnh quy hoạch chung xây dựng xã Tân Hưng, huyện Vĩnh Bảo đến năm 2025",
      category: "quy-hoach",
      client: "UBND xã Tân Hưng",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập đồ án điều chỉnh quy hoạch chung",
      services: ["Lập đồ án điều chỉnh quy hoạch chung"]
    },
    
    // Hoạt động đo đạc và bản đồ
    {
      id: 5,
      title: "Dự án thành phần 2 - Thu hồi đất, bồi thường, hỗ trợ, giải phóng mặt bằng - Dự án đầu tư xây dựng cầu Nguyễn Trãi",
      category: "do-dac",
      client: "Ban quản lý dự án đầu tư xây dựng các công trình giao thông và nông nghiệp Hải Phòng",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập bản đồ địa chính tỷ lệ 1/500",
      services: ["Lập bản đồ địa chính tỷ lệ 1/500"]
    },
    {
      id: 6,
      title: "Đo đạc và lập bản đồ hiện trạng, bản vẽ mặt cắt hiện trạng khu vực khai thác khoáng sản mỏ đá vôi Núi Ngà Voi (Ông Hậu)",
      category: "do-dac",
      client: "Công ty cổ phần xi măng Bạch Đằng",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập bản đồ hiện trạng và lập mặt cắt hiện trạng",
      services: ["Lập bản đồ hiện trạng", "Lập mặt cắt hiện trạng"]
    },
    {
      id: 7,
      title: "Dự án Đầu tư xây dựng bến số 5, số 6 khu bến cảng Lạch Huyện thuộc cảng biển Hải Phòng",
      category: "do-dac",
      client: "Công ty TNHH cảng container quốc tế Hateco Hải Phòng",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập mảnh trích đo địa chính và cắm mốc chỉ giới phục vụ công tác giao đất",
      services: ["Lập mảnh trích đo địa chính", "Cắm mốc chỉ giới phục vụ công tác giao đất"]
    },
    {
      id: 8,
      title: "Khảo sát, đo đạc và lập bản đồ hiện trạng cho khu vực mỏ đá vôi và mỏ sét",
      category: "do-dac",
      client: "Công ty Xi măng Chinfon",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập bản đồ hiện trạng và lập mặt cắt hiện trạng phục vụ báo cáo tình hình khai thác thực tế",
      services: ["Lập bản đồ hiện trạng", "Lập mặt cắt hiện trạng"]
    },
    {
      id: 9,
      title: "Dự án xây dựng các công trình thực hiện tiêu chí xã nông thôn mới kiểu mẫu tại xã Nhân Hòa",
      category: "do-dac",
      client: "Ban quản lý dự án đầu tư xây dựng huyện Vĩnh Bảo",
      location: "Hải Phòng",
      year: "2025",
      description: "Lập bản đồ địa chính và cắm mốc phục vụ công tác bồi thường giải phóng mặt bằng",
      services: ["Lập bản đồ địa chính", "Cắm mốc phục vụ công tác bồi thường giải phóng mặt bằng"]
    },
    
    // Lĩnh vực khảo sát xây dựng
    {
      id: 10,
      title: "Xây dựng nhà máy sản xuất sản phẩm từ plastic",
      category: "khao-sat",
      client: "Công ty TNHH Jingsheng Việt Nam",
      location: "Hải Phòng",
      year: "2025",
      description: "Khoan khảo sát địa chất công trình",
      services: ["Khoan khảo sát địa chất công trình"]
    },
    {
      id: 11,
      title: "Nhà xưởng sản suất và kho 5 tầng - Dự án Zhong Xin Ya Tai Việt Nam – Lô L1.9A Khu công nghiệp Đồ Sơn",
      category: "khao-sat",
      client: "Công ty TNHH Zhong Việt Nam",
      location: "Hải Phòng",
      year: "2025",
      description: "Khoan khảo sát địa chất công trình",
      services: ["Khoan khảo sát địa chất công trình"]
    },
    {
      id: 12,
      title: "Khảo sát địa hình, địa chất, lập thiết kế bản vẽ thi công và dự toán xây dựng Dự án đầu tư xây dựng công trình bổ sung, cải thiện chất lượng nguồn nước Sông Rế",
      category: "khao-sat",
      client: "Ban quản lý dự án ĐTXD các công trình nông nghiệp và phát triển nông thôn",
      location: "Hải Phòng",
      year: "2025",
      description: "Khảo sát địa hình và khoan khảo sát địa chất công trình",
      services: ["Khảo sát địa hình", "Khoan khảo sát địa chất công trình"]
    },
    {
      id: 13,
      title: "Trường THPT Kiến An - Cải tạo, nâng cấp hội trường và các công trình phụ trợ",
      category: "khao-sat",
      client: "Trường THPT Kiến An",
      location: "Hải Phòng",
      year: "2025",
      description: "Khoan khảo sát địa chất công trình",
      services: ["Khoan khảo sát địa chất công trình"]
    },
    
    // Hoạt động thí nghiệm chuyên ngành xây dựng
    {
      id: 14,
      title: "Công trình Cải tạo, nâng cấp các công trình văn hóa trên địa bàn xã Quang Trung thực hiện tiêu chí xây dựng nông thôn mới kiểu mẫu",
      category: "thi-nghiem",
      client: "Công ty Cổ phần đầu tư xây dựng thương mại Tuấn Khôi",
      location: "Hải Phòng",
      year: "2025",
      description: "Thí nghiệm vật liệu xây dựng",
      services: ["Thí nghiệm vật liệu xây dựng"]
    },
    {
      id: 15,
      title: "Dự án Khu đô thị mới Ngã Năm - Sân bay Cát Bi, gói thầu Xây dựng hạ tầng kỹ thuật lô 26BC",
      category: "thi-nghiem",
      client: "Đội thi công và phá dỡ - Công ty TNHH MTV Thương mại đầu tư phát triển đô thị",
      location: "Hải Phòng",
      year: "2025",
      description: "Thí nghiệm vật liệu xây dựng",
      services: ["Thí nghiệm vật liệu xây dựng"]
    },
    {
      id: 16,
      title: "Xây mới nhà đa năng trường THCS An Thắng",
      category: "thi-nghiem",
      client: "Ban quản lý dự án ĐTXD các công trình nông nghiệp và phát triển nông thôn",
      location: "Hải Phòng",
      year: "2025",
      description: "Thí nghiệm nén tải trọng tĩnh cọc bê tông công trình",
      services: ["Thí nghiệm nén tải trọng tĩnh cọc bê tông công trình"]
    },
    {
      id: 17,
      title: "Khoan kiểm tra chiều dày BTN và Base xác định mô đun đàn hồi nền mặt đường bằng cần đo võng Benkelman tại các tuyến đường Deep2",
      category: "thi-nghiem",
      client: "Công ty cổ phần Khu công nghiệp Hải Phòng",
      location: "Hải Phòng",
      year: "2025",
      description: "Khoan khảo sát và thí nghiệm",
      services: ["Khoan khảo sát", "Thí nghiệm"]
    }
  ];

  const categories = [
    { id: 'all', name: 'Tất cả dự án' },
    { id: 'quy-hoach', name: 'Quy hoạch' },
    { id: 'do-dac', name: 'Đo đạc & Bản đồ' },
    { id: 'khao-sat', name: 'Khảo sát' },
    { id: 'thi-nghiem', name: 'Thí nghiệm' },
    { id: 'tu-van', name: 'Tư vấn' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <div className="projects-page">
      <div className="container">
        {/* Page Header */}
        <section className="page-header">
          <h1>Dự án tiêu biểu năm 2025</h1>
          <p>17 dự án mới nhất của DSC.JSC tại Hải Phòng theo hồ sơ năng lực cập nhật</p>
        </section>

        {/* Filter Buttons */}
        <section className="filter-section">
          <div className="filter-buttons">
            {categories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
                onClick={() => setActiveFilter(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </section>

        {/* Projects Grid */}
        <section className="projects-grid">
          {filteredProjects.map(project => (
            <div key={project.id} className="project-card">
              <div className="project-content">
                <h3>{project.title}</h3>
                <div className="project-meta">
                  <span className="client">🏢 {project.client}</span>
                  <span className="location">📍 {project.location}</span>
                  <span className="year">📅 {project.year}</span>
                </div>
                
                <p className="project-description">{project.description}</p>
                
                <div className="project-services">
                  <h4>Phạm vi công việc:</h4>
                  <ul>
                    {project.services.map((service, index) => (
                      <li key={index}>{service}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* Project Gallery */}
        <section className="project-gallery">
          <h2>Hình ảnh dự án thực tế</h2>
          <p>Một số hình ảnh từ các dự án đã thực hiện của DSC.JSC</p>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img src="/images/somePic/G1.jpg" alt="Dự án khảo sát địa chất" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/G2.jpg" alt="Thiết bị khảo sát hiện trường" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/G3.jpg" alt="Công tác đo đạc địa hình" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/G4.jpg" alt="Khảo sát công trình xây dựng" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/G5.jpg" alt="Thí nghiệm vật liệu xây dựng" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/PCTT.jpg" alt="Phòng chống thiên tai" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/z7706165505763_4303d9c7bc10ff86f67fe4e7b7168726.jpg" alt="Hiện trường dự án" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/z7706241014025_74ab816fb7ff4ab15581de64b8c3f309.jpg" alt="Công tác khảo sát" />
            </div>
            <div className="gallery-item">
              <img src="/images/somePic/z7706247453814_b65b59bb4ad09984aeb4b6be7532024b.jpg" alt="Dự án thực tế" />
            </div>
          </div>
        </section>

        {/* Statistics */}
        <section className="project-stats">
          <h2>Thống kê dự án năm 2025</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">17</div>
              <div className="stat-label">Dự án mới</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">5</div>
              <div className="stat-label">Đo đạc & Bản đồ</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">4</div>
              <div className="stat-label">Khảo sát</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">4</div>
              <div className="stat-label">Thí nghiệm</div>
            </div>
          </div>
        </section>

        {/* Capabilities */}
        <section className="capabilities">
          <h2>Năng lực thực hiện</h2>
          <div className="capabilities-grid">
            <div className="capability-item">
              <div className="capability-icon">🏗️</div>
              <h4>Dự án lớn</h4>
              <p>Có khả năng thực hiện các dự án quy mô lớn từ 100-1000 ha</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">⚡</div>
              <h4>Tiến độ nhanh</h4>
              <p>Cam kết hoàn thành đúng tiến độ với chất lượng cao</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">🎯</div>
              <h4>Chính xác cao</h4>
              <p>Sử dụng công nghệ hiện đại đảm bảo độ chính xác tối đa</p>
            </div>
            <div className="capability-item">
              <div className="capability-icon">🤝</div>
              <h4>Hợp tác đa ngành</h4>
              <p>Phối hợp với nhiều đơn vị chuyên môn khác nhau</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Projects;